import { useCallback, useEffect, useState } from 'react';

import { hrApi } from '@/api';

import { EmployeeSelect } from '@/components/selects';

import { PageHeader } from '@/components/layout/PageHeader';

import { Input } from '@/components/ui/Input';

import { DatePicker } from '@/components/ui/DatePicker';

import { FormGrid } from '@/components/ui/FormGrid';

import { FormActions } from '@/components/ui/FormActions';

import { showApiError } from '@/utils/apiError';

import { RecordDataTable } from '@/components/ui/RecordDataTable';
import { notify } from '@/core/toast/notify';



export function HrTravelPage() {

  const [requests, setRequests] = useState<unknown[]>([]);

  const [employeeId, setEmployeeId] = useState('');

  const [purpose, setPurpose] = useState('');

  const [destination, setDestination] = useState('');

  const [departure, setDeparture] = useState('');



  const load = useCallback(async () => {

    try {

      setRequests(await hrApi.listTravel());

    } catch (err) {

      showApiError(err, 'Failed to load travel requests');

    }

  }, []);



  useEffect(() => {

    load();

  }, [load]);



  const submit = async () => {

    try {

      await hrApi.createTravel({ employeeId: Number(employeeId), purpose, destination, departureDate: departure });

      notify.success('Travel request submitted');

      load();

    } catch (err) {

      showApiError(err, 'Submit failed');

    }

  };



  return (

    <div>

      <PageHeader title="Travel management" description="Travel requests, approval, and settlement" breadcrumbs={[{ label: 'HR', to: '/hr' }, { label: 'Travel' }]} />

      <div className="card mb-4 p-4">
        <FormGrid columns={2}>
          <EmployeeSelect value={employeeId} onChange={setEmployeeId} hrScoped />
          <Input label="Destination" value={destination} onChange={(e) => setDestination(e.target.value)} />
          <Input label="Purpose" value={purpose} onChange={(e) => setPurpose(e.target.value)} />
          <DatePicker label="Departure" value={departure} onChange={setDeparture} />
        </FormGrid>
        <FormActions
          primaryLabel="Submit request"
          onPrimary={() => void submit()}
          onReset={() => {
            setEmployeeId('');
            setDestination('');
            setPurpose('');
            setDeparture('');
          }}
        />
      </div>

      <RecordDataTable data={requests} emptyTitle="No travel requests" />

    </div>

  );

}


